import {
  Tooltip, Popover, Offcanvas, Modal,
} from 'bootstrap5';

require('@popperjs/core');

// Hack for mobile ap WebView, them do not know about Object.groupBy (tested on iOs)
if (typeof Object.groupBy !== 'function') {
  Object.groupBy = (array, keyGetter) => array.reduce((result, item, index) => {
    const key = keyGetter(item, index);
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(item);
    return result;
  }, {});
}

// Support component names relative to this directory:
const componentRequireContext = require.context('components', true);

const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);

window.addEventListener('load', () => {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

  const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  popoverTriggerList.map((popoverTriggerEl) => new Popover(popoverTriggerEl));

  const offcanvasTriggerList = [].slice.call(document.querySelectorAll('.offcanvas'));
  offcanvasTriggerList.map((offcanvasTriggerEl) => new Offcanvas(offcanvasTriggerEl));

  const modalTriggerList = [].slice.call(document.querySelectorAll('.modal'));
  modalTriggerList.map((modalTriggerEl) => {
    const modalEl = new Modal(modalTriggerEl);

    if (modalTriggerEl.classList.contains('show-by-default')) {
      modalEl.show();
    }

    return modalEl;
  });

  function addAutoResize() {
    document.querySelectorAll('[data-autoresize]').forEach((element) => {
      element.style.boxSizing = 'border-box';
      const offset = element.offsetHeight - element.clientHeight;
      element.addEventListener('input', (event) => {
        event.target.style.height = 'auto';
        event.target.style.height = `${event.target.scrollHeight + offset}px`;
      });
      element.removeAttribute('data-autoresize');
    });
  }

  addAutoResize();

  window.aiChatOpen = document.body.classList.contains('page-chat-open');

  // OPEN AI COACH CHAT
  document.querySelectorAll('.navigation-ai-coach-chat').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.aiChatOpen) {
        document.body.classList.remove('page-chat-open');
        window.aiChatOpen = false;
      } else {
        document.body.classList.add('page-chat-open');
        window.aiChatOpen = true;
      }
    });
  });

  // NAVIGATION MENU
  const menuItems = document.querySelectorAll('.menu-item');

  menuItems.forEach((menuItem) => {
    const submenu = menuItem.parentElement.parentElement.querySelector('.submenu');
    const chevron = menuItem.querySelector('.chevron-toggle');

    if (submenu && chevron) {
      submenu.addEventListener('show.bs.collapse', () => {
        chevron.style.transform = 'rotate(-180deg)';
      });
      submenu.addEventListener('hide.bs.collapse', () => {
        chevron.style.transform = 'rotate(0)';
      });
    }

    menuItem.addEventListener('show.bs.collapse', (e) => {
      if (window.aiChatOpen) {
        e.preventDefault();
        e.stopPropagation();
        document.body.classList.remove('page-chat-open');
        setTimeout(() => { // HACK TO PASS SHOWN EVENT
          window.aiChatOpen = false;
        }, 1000);
        return;
      }
      if (submenu) {
        submenu.classList.remove('position-absolute');
      }
    });

    menuItem.addEventListener('shown.bs.collapse', () => {
      if (window.aiChatOpen) {
        return;
      }
      fetch('/users/options', {
        method: 'POST',
        body: JSON.stringify({ options: { 'menu-type': 'expanded' } }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
        },
      })
        .then((_response) => {
          if (submenu) {
            submenu.classList.remove('position-absolute');

            if (menuItem.parentElement.classList.contains('active')) {
              submenu.classList.add('show');
              chevron.style.transform = 'rotate(-180deg)';
            }
          }
        });
    });

    menuItem.addEventListener('hide.bs.collapse', (e) => {
      if (window.aiChatOpen) {
        e.preventDefault();
        e.stopPropagation();
        document.body.classList.remove('page-chat-open');
        setTimeout(() => { // HACK TO PASS HIDEN EVENT
          window.aiChatOpen = false;
        }, 1000);
        return;
      }
      if (submenu) {
        submenu.classList.add('position-absolute');
      }
    });

    menuItem.addEventListener('hidden.bs.collapse', () => {
      if (window.aiChatOpen) {
        return;
      }

      fetch('/users/options', {
        method: 'POST',
        body: JSON.stringify({ options: { 'menu-type': 'minimize' } }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
        },
      })
        .then((_response) => {
          if (submenu) {
            submenu.classList.add('position-absolute');
          }
        });
    });
  });

  // MOBILE MENU
  const mobileMenu = document.getElementById('menu');
  mobileMenu.addEventListener('show.bs.offcanvas', () => {
    if (window.aiChatOpen) {
      document.body.classList.remove('page-chat-open');
      window.aiChatOpen = false;
    }
  });

  // INPUTS

  const decrementButtons = document.querySelectorAll('.btn-decrement');

  decrementButtons.forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();

      const input = element.parentElement.querySelector('input');
      input.stepDown();
    });
  });

  const incrementButtons = document.querySelectorAll('.btn-increment');

  incrementButtons.forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();

      const input = element.parentElement.querySelector('input');
      input.stepUp();
    });
  });

  const switchInputs = document.querySelectorAll('.switch-boolean');

  switchInputs.forEach((element) => {
    element.addEventListener('change', () => {
      if (element.dataset.for) {
        const input = document.getElementById(element.dataset.for);
        input.toggleAttribute('disabled');

        const buttons = element.closest('.info').querySelectorAll('.btn-decrement, .btn-increment');
        buttons.forEach((btn) => btn.classList.toggle('disabled'));
      }
    });
  });

  // ONBOARDING

  const cpaFormInputs = document.querySelectorAll('#cpa-form input');
  const progressBar = document.getElementById('progress');

  cpaFormInputs.forEach((element) => {
    element.addEventListener('input', () => {
      const oldValue = parseInt(progressBar.getAttribute('aria-valuenow'), 10);
      const newValue = oldValue + Math.floor(100 / 5);

      progressBar.setAttribute('aria-valuenow', newValue);
      progressBar.style.width = `${newValue}%`;
      progressBar.innerHTML = `${newValue}%`;
    });
  });

  const increaseProgress = (element) => {
    const oldValue = parseInt(element.getAttribute('aria-valuenow'), 10);

    if (oldValue >= 100) {
      document.location.href = element.getAttribute('data-link');
      return;
    }

    const newValue = oldValue + 1;

    element.setAttribute('aria-valuenow', newValue);
    element.style.width = `${newValue}%`;
    element.innerHTML = `${newValue}%`;

    setTimeout(() => { increaseProgress(element); }, 80);
  };

  if (progressBar && cpaFormInputs.length === 0) {
    setTimeout(() => { increaseProgress(progressBar); }, 80);
  }

  const fieldsets = document.querySelectorAll('.scrolling-form fieldset');

  fieldsets.forEach((fieldset) => {
    const inputs = fieldset.querySelectorAll('input');

    inputs.forEach((input) => {
      input.addEventListener('input', () => {
        fieldset.disabled = true;
        fieldset.classList.add('text-muted');

        const sibling = fieldset.nextElementSibling;

        if (sibling.tagName === 'DIV') {
          sibling.querySelector('input').classList.remove('disabled');
        } else {
          sibling.disabled = false;
          sibling.classList.remove('text-muted');
          sibling.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  });

  const coachInfo = document.getElementById('coach-info');

  if (coachInfo) {
    const coachInfoBtn = document.getElementById('coach-info-button');

    coachInfo.addEventListener('hide.bs.collapse', () => {
      coachInfoBtn.textContent = 'Show Details';
    });
    coachInfo.addEventListener('show.bs.collapse', () => {
      coachInfoBtn.textContent = 'Hide Details';
    });
  }

  // IMPERSONATE
  document.querySelectorAll('.revert-impersonate-link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const form = document.getElementById('revert-form');
      if (form) {
        form.submit();
      }
    });
  });
});
